// extracted by mini-css-extract-plugin
module.exports = {"XBoost":"XBoost_XBoost__LRGD_"};